export default __webpack_public_path__ + "static/media/clipplane.990b6855.frag";